/* eslint-disable no-unexpected-multiline */
/* eslint-disable no-restricted-globals */
const lozad = require('lozad');
const createTrapFocus = require('../components/accessibility/focusTrap');

const $compareBar = $('.prod-compare.cta-bar-container');
const maxSlots = parseInt($('.prod-compare .cta-bar').data('max-slots'), 10);
let productsForComparison = [];
const compareButtonText = $('button.compare').text();

// eslint-disable-next-line no-restricted-globals
let lastKnownUrl = location.href;

/**
 * Trigger lozad
 */
function triggerLozad() {
    const observer = lozad();
    observer.observe();
}

/**
 * @typedef ProductComparisonList
 * @type Object
 * @property {string} pid - ID for product to compare
 * @property {string} imgSrc - Image URL for selected product
 */

/**
 * Compiles the HTML for a single slot
 *
 * @param {ProductComparisonList} product - Selected product to compare
 * @param {number} idx - Slot number (zero-based)
 * @return {string} - HTML for a single slot
 */
function compileSlot(product, idx) {
    const { pid } = product;
    const name = `pid${idx}`;
    const removeLabel = $('.prod-compare .cta-bar').data('remove-label') || 'Remove product from comparison';

    return (
        `${'<div class="col-3 selected-product"><div class="slot" data-pid="'}${pid}">`
        + `<img src="${product.imgSrc}" />`
        + '<div class="close">'
        + `<button type="button" class="icon-cross-line no-btn" aria-label="${removeLabel}"></button>`
        + '</div>'
        + '</div>'
        + `<input type="hidden" name="${name}" value="${pid}" />`
        + '</div>\n'
    );
}

/**
 * Draw and render the Compare Bar product slots
 *
 * @param {ProductComparisonList []} productsToCompare - List of ID's of the products to compare
 */
function redrawCompareSlots(productsToCompare) {
    let html = productsToCompare.map((product, idx) => compileSlot(product, idx)).join('');

    // Render empty slots
    if (productsToCompare.length < maxSlots) {
        const numAvailableSlots = maxSlots - productsToCompare.length;

        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < numAvailableSlots; i++) {
			const slotNumber = productsToCompare.length + i + 1;
            if (i === 0 && productsToCompare.length < 2) {
                html += `${'<div class="col-3 selected-product"><div class="slot">'
                    + '<div class="min-products-msg">'}${$('.prod-compare .cta-bar').data(
                    'min-products-msg',
                )}</div><div class="slot-number">${slotNumber}</div></div></div>`;
            } else {
                html += `<div class="col-3 selected-product"><div class="slot"><div class="slot-number">${slotNumber}</div></div></div>`;
            }
        }
    }

    $('.prod-compare .cta-bar .product-slots')
        .empty()
        .append(html);
}

/**
 * Enables/disables the Compare button, depending on whether at least two products have been
 * selected for comparison
 *
 * @param {number} numProducts - Number of products selected for comparison
 */
function setCompareButton(numProducts) {
    const buttonCompare = $('button.compare');
    if (numProducts > 0) {
        buttonCompare.text(`${compareButtonText}`);
    } else {
        buttonCompare.text(compareButtonText);
    }

    if (numProducts < 2) {
        buttonCompare.attr('disabled', true);
    } else {
        buttonCompare.removeAttr('disabled');
    }
}

/**
 * Returns a copy of a list of products to compare
 *
 * @param {ProductComparisonList []} productsToCompare - List of ID's of the products to compare
 * @return {ProductComparisonList []} List of ID's of the products to compare
 */
function copyProducts(productsToCompare) {
    return productsToCompare.map((product) => {
        const proxy = {};

        Object.keys(product).forEach((key) => {
            proxy[key] = product[key];
        });

        return proxy;
    });
}

/**
 * Releases the Compare Bar focus trap and returns focus to the checkbox that opened it
 * @return {undefined}
 */
function releaseCompareBarFocus() {
    const release = $compareBar.data('releaseFocus');
    if (typeof release === 'function') {
        release();
    }
    $compareBar.data('releaseFocus', null);
}

/**
 * Traps focus within the Compare Bar while it is visible. Escape releases the trap
 * so the user can keep navigating the product grid
 * @return {undefined}
 */
function trapCompareBar() {
    if ($compareBar.length && $compareBar.is(':visible')
        && typeof $compareBar.data('releaseFocus') !== 'function') {
        const release = createTrapFocus.trapFocus($compareBar, releaseCompareBarFocus);
        $compareBar.data('releaseFocus', release);
    }
}

/**
 * Handles the selection of a product for comparison
 *
 * @param {ProductComparisonList []} products - List of ID's of the products to compare
 * @param {string} pid - ID for product to compare
 * @param {string} imgSrc - Image URL for selected product
 * @return {ProductComparisonList []} List of ID's of the products to compare
 */
function selectProduct(products, pid, imgSrc) {
    const productsToCompare = copyProducts(products) || [];

    if (productsToCompare.length < maxSlots) {
        productsToCompare.push({
            pid,
            imgSrc,
        });

        if (productsToCompare.length === maxSlots) {
            $('input[type=checkbox]:not(:checked)').attr('disabled', true);
        }

        redrawCompareSlots(productsToCompare);
        setCompareButton(productsToCompare.length);
        if ($compareBar.hasClass('compareDown') || $compareBar.hasClass('compareTop')) {
            $('.hide-cta').trigger('click');
        }
        $compareBar.show();
        trapCompareBar();
    }

    return productsToCompare;
}

/**
 * Handles the deselection of a product
 *
 * @param {ProductComparisonList []} products - List of ID's of the products to compare
 * @param {string} pid - ID for product to compare
 * @return {ProductComparisonList []} List of ID's of the products to compare
 */
function deselectProduct(products, pid) {
    let productsToCompare = copyProducts(products) || [];

    productsToCompare = productsToCompare.filter(product => product.pid !== pid);

    if (productsToCompare.length === 0) {
        releaseCompareBarFocus();
        $compareBar.hide();
    }

    $(`input#${pid}`).prop('checked', false);
    $('input[type=checkbox]:not(:checked)').removeAttr('disabled');

    redrawCompareSlots(productsToCompare);
    setCompareButton(productsToCompare.length);
    return productsToCompare;
}

/**
 * Clears the Compare Bar and hides it
 * @return {undefined}
 */
function clearCompareBar() {
    productsForComparison.forEach(function (product) {
        $(this).trigger('compare:deselected', { pid: product.pid });
    });

    productsForComparison = [];
    $('.compare input').prop('checked', false);
    $('.compare input[type=checkbox]:not(:checked)').removeAttr('disabled');
    releaseCompareBarFocus();
    $compareBar.hide();
}

/**
 * Update form action url to not have query string
 * @returns {undefined}
 */
function updateSubmitUrl() {
    const form = $('.compare-products-form');
    const targetUrl = form.data('action');
    const urlParts = targetUrl.split('?');
    if (urlParts[1]) {
        urlParts[1].split('&').forEach((keyValue) => {
            const splittedValues = keyValue.split('=');
            const key = decodeURIComponent(splittedValues[0]);
            const value = decodeURIComponent(splittedValues[1]);
            if (key && value) {
                if (form.find(`[name="${key}"]`).length === 0) {
                    form.append(`<input type="hidden" name="${key}" value="${value}" />`);
                }
            }
        });
        form.attr('action', urlParts[0]);
    }
}

module.exports = {
    /**
     * Handles Compare checkbox click
     */
    handleCompareClick() {
		$('div.page').on('keydown', '.compare input[type=checkbox]', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                $(e.currentTarget).trigger('click');
            }
        });

        $('div.page').on('click', '.compare input[type=checkbox]', (e) => {
            const target = $(e.currentTarget);
            const pid = target.attr('id');
            const checked = target.is(':checked');
            const imgSrc = target
                .closest('.product-tile')
                .find('.tile-image')
                .data('src');

            if (checked) {
                productsForComparison = selectProduct(productsForComparison, pid, imgSrc);
                target.trigger('compare:selected', { pid });
            } else {
                productsForComparison = deselectProduct(productsForComparison, pid);
                target.trigger('compare:deselected', { pid });
            }
        });
    },

    /**
     * Handles the Clear All link
     */
    handleClearAll() {
        $('.prod-compare .cta-bar a.clear-all').on('click', (e) => {
            e.preventDefault();
            clearCompareBar();
        });
    },

    /**
     * Handles deselection of a product on the Compare Bar
     */
    deselectProductOnCompareBar() {
        $('.prod-compare .cta-bar, #product-compare-modal').on('click', '.close', (e) => {
            const target = $(e.currentTarget);
            const pid = target.closest('.slot').data('pid') || target.data('pid');
            const parentHeader = target.parents('.product-header');

            productsForComparison = deselectProduct(productsForComparison, pid.toString());
            target.trigger('compare:deselected', { pid });

            if (parentHeader.length > 0) {
                const parentTR = parentHeader.parent();
                if (parentTR.find('.product-header').length > 2) {
                    const parentIndex = parentHeader.index();

                    // remove the product attributes
                    $('#product-compare-modal .table-striped-column')
                        .find('tbody > tr')
                        .each((_index, value) => {
                            const removeTD = $(value).find('td')[parentIndex - 1];
                            if (removeTD) {
                                removeTD.remove();
                            }
                        });

                    // remove the product tile
                    parentHeader.remove();

                    const tableHeaders = $('#product-compare-modal .table-striped-column .product-header');
                    const countColumns = tableHeaders.length;
                    const columnsWidth = 100 / countColumns;
                    tableHeaders.css('width', `${columnsWidth}%`);
                } else {
                    $('.product-compare-modal > .modal-header')
                        .find('.icon-cross-line')
                        .click();
                }
            }
        });
    },

    /**
     * Selects products for comparison based on the checked status of the Compare checkboxes in
     * each product tile.  Used when user goes back from the Compare Products page.
     */
    selectCheckedProducts() {
        $('.product-grid').ready(() => {
            const navEntry = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
            const isReload = navEntry
                ? navEntry.type === 'reload'
                : !!(performance.navigation && performance.navigation.type === 1);

            if (location.hash && !isReload) {
                location.hash
                    .replace('#', '')
                    .split(',')
                    .forEach((id) => {
                        $(`input#${id}`).prop('checked', 'checked');
                    });
            } else {
                clearCompareBar();
            }
            $('.compare input:checked').each(function () {
                const pid = $(this).prop('id');
                const imgSrc = $(this)
                    .closest('.product-tile')
                    .find('img.tile-image')
                    .prop('src');
                productsForComparison = selectProduct(productsForComparison, pid, imgSrc);
                $(this).trigger('compare:selected', { pid });
            });
        });
    },

    /**
     * Sets the "backUrl" property to the last attribute selected URL to ensure that when the user
     * goes back from the Compare Products page, the previously selected attributes are still
     * selected and applied to the previous search.
     */
    setBackUrl() {
        $('.search-results').on('click', '.refinements a', function () {
            $('input[name="backUrl"]').val($(this).prop('href'));
        });
    },

    /**
     * Sets the history.pushState for history.back() to work from the Compare Products page.
     */
    setPushState() {
        $('#product-compare-modal')
            .off('shown.bs.modal.a11y hidden.bs.modal.a11y')
            .on('shown.bs.modal.a11y', () => {
                const $modal = $('#product-compare-modal');
                const release = createTrapFocus.trapFocus($modal, () => {
                    $modal.modal('hide');
                });
                $modal.data('releaseFocus', release);
            })
            .on('hidden.bs.modal.a11y', () => {
                const $modal = $('#product-compare-modal');
                const release = $modal.data('releaseFocus');
                if (typeof release === 'function') {
                    release();
                }
                $modal.data('releaseFocus', null);
                const trigger = $modal.data('trigger');
                if (trigger && typeof trigger.focus === 'function') {
                    trigger.focus();
                }
            });

        $('.compare-products-form  button.compare').on('click', (e) => {
            e.preventDefault();

			$('#product-compare-modal').data('trigger', e.currentTarget);

            // hide de product compare bar

            $('.hide-cta').click();

            updateSubmitUrl();

            const target = $(e.currentTarget);
            const pageUrl = target.parents('.compare-products-form').data('action');
            const selectedProducts = $('.compare input:checked')
                .map(function () {
                    return this.id;
                })
                .get()
                .join(',');

            window.history.pushState({}, document.title, `${lastKnownUrl}#${selectedProducts}`);
            location.hash = selectedProducts;

            const data = {
                selectedProducts,
            };

            $.ajax({
                url: `${pageUrl}#${selectedProducts}`,
                method: 'GET',
                data,
                success(response) {
                    $('#product-compare-modal')
                        .modal('show')
                        .find('.modal-body')
                        .html(response);

                    triggerLozad();
                    $.spinner().stop();
                },
                error() {
                    $.spinner().stop();
                },
            });
        });
    },
    catchFilterChange() {
        $('.container').on('click', '.refinements li a, .refinement-bar a.reset', (e) => {
            e.preventDefault();
            clearCompareBar();
        });
    },
    listenToFilterChange() {
        $('body').on('search:filter', (e, data) => {
            lastKnownUrl = data.currentTarget.href;
        });
    },
    toggleViewOfCompareBar() {
        $('body').on('click', '.hide-cta', (e) => {
            $('.hide-cta > .text-show').toggle();
            $('.hide-cta > .text-hidden').toggle();

            if ($compareBar.hasClass('position-bottom')) {
                $compareBar.toggleClass('compareDown');
            } else {
                $compareBar.toggleClass('compareTop');
            }

            const collapsed = $compareBar.hasClass('compareDown') || $compareBar.hasClass('compareTop');
            $(e.currentTarget).attr('aria-expanded', String(!collapsed));
            if (collapsed) {
                releaseCompareBarFocus();
            } else {
                trapCompareBar();
            }
        });
    },
    closeModal() {
        $('#product-compare-modal').on('click', '.modal-header > .icon-cross-line, .overlay', () => {
            window.history.back();
            $('#product-compare-modal').modal('hide');
        });
    },
};
